<app-top-bar [isBack]="true" [title]="'Коментар'"></app-top-bar>
<div class="support-comment-container">
  <div class="create-block block-background"
       [formGroup]="commentForm"
  >
    <mat-form-field class="create-form-field default-background" appearance="outline">
      <textarea matInput
                focus-me
                cdkTextareaAutosize
                formControlName="comment"
                #message
                maxlength="500"
                placeholder="Вкажіть коментар (не обов’язково)">
        </textarea>
      <mat-hint class="hint-color" align="start">{{message.value.length}} / 500</mat-hint>
    </mat-form-field>
    <button class="main-button positive-button accent-color-background button-border-color-accent"
            (click)="submitForm()"
            [disabled]="commentForm.invalid || changeStatusLoading"
            [ngStyle]="{'opacity': commentForm.invalid || changeStatusLoading ? '0.5' : '1'}"
            mat-flat-button>
      {{planningStatus === 'reopen' ? 'Перевідкрити звернення' : 'Завершити звернення'}}
    </button>
  </div>
</div>
